export const RecommendedProductConst = {
  MAIN_BANNER: '메인 배너',
  GREEN_TRAVEL_AGENCY_RECOMMENDED: '그린여행사의 추천 상품',
  THIS_MONTH_RECOMMENDED: '이달의 추천 상품',
  CATEGORY_RECOMMENDED: '카테고리별 추천 상품',
};
